export const REVIEW_SUBMIT_SUCCESS = 'Feedback submitted successfully.';
export const REVIEW_DIALOG_TITLE = 'Share your feedback';
